var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._m(0),_c('div',{staticClass:"vertical-timeline-content"},[_c('h5',[_vm._v("Вход в систему")]),_c('span',{staticClass:"vertical-date"},[_vm._v(" "+_vm._s(_vm.action.date)+" "),_c('small',[_vm._v(_vm._s(_vm.action.time))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vertical-timeline-icon navy-bg"},[_c('i',{staticClass:"fa fa-sign-in"})])
}]

export { render, staticRenderFns }